<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card>
      <HeaderDividerBlock headerText="Update Role"></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="form.name"
              required
              label="Role Name*"
            ></v-text-field>
          </v-col>

          <!-- Branch -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="branchPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllBranch"
                        @click="toggleSelectAllBranch()"
                        label="Branch"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in branchPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.branch"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Store -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="storePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllStore"
                        @click="toggleSelectAllStore()"
                        label="Store"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in storePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.store"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- customer -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="customerPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllCustomer"
                        @click="toggleSelectAllCustomer()"
                        label="Customer"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in customerPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.customer"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Suppliers -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="suppliersPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllSuppliers"
                        @click="toggleSelectAllSuppliers()"
                        label="Suppliers"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in suppliersPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.Suppliers"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Product -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="productPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllProduct"
                        @click="toggleSelectAllProduct()"
                        label="Product"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.product"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Product Tax -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="productTaxPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllProductTax"
                        @click="toggleSelectAllProductTax()"
                        label="Product Tax"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productTaxPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.productTax"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Requisition -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="requisitionPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllRequisition"
                        @click="toggleSelectAllRequisition()"
                        label="Requisition"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in requisitionPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.requisition"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Purchase Order -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="purchaseOrderPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllPurchaseOrder"
                        @click="toggleSelectAllPurchaseOrder()"
                        label="Purchase Order"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in purchaseOrderPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.purchase_order"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GRN -->
          <v-col xs="12" sm="12" md="12" lg="6" xl="3" v-if="grnPer.length > 0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGrn"
                        @click="toggleSelectAllGrn()"
                        label="GRN"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in grnPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.grn"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Stock -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="stockPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllStock"
                        @click="toggleSelectAllStock()"
                        label="Stock"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in stockPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.stock"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Batch -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="batchPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllBatch"
                        @click="toggleSelectAllBatch()"
                        label="Batch"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in batchPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.batch"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Stock Transfer -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="stockTransferPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllStockTransfer"
                        @click="toggleSelectAllStockTransfer()"
                        label="Stock Transfer"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in stockTransferPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.stock_transfer"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Goods Return Note -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="goodsReturnNotePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGoodsReturnNote"
                        @click="toggleSelectAllGoodsReturnNote()"
                        label="Goods Return Note"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in goodsReturnNotePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.goods_return_note"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Expenses -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="expensesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllExpenses"
                        @click="toggleSelectAllExpenses()"
                        label="Expenses"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in expensesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.expenses"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Expense Types -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="expenseTypesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllExpenseTypes"
                        @click="toggleSelectAllExpenseTypes()"
                        label="Expense Types"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in expenseTypesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.expense_types"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GL Account -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="glAccountPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGlAccount"
                        @click="toggleSelectAllGlAccount()"
                        label="GL Account"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in glAccountPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.gl_account"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GL Sub Headers -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="glSubHeadersPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGlSubHeaders"
                        @click="toggleSelectAllGlSubHeaders()"
                        label="GL Sub Headers"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in glSubHeadersPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.gl_sub_headers"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- GL Transactions -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="glTransactionsPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllGlTransactions"
                        @click="toggleSelectAllGlTransactions()"
                        label="GL Transactions"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in glTransactionsPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.GL_Transactions"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Trial Balance -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="trialBalancePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllTrialBalance"
                        @click="toggleSelectAllTrialBalance()"
                        label="Trial Balance"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in trialBalancePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.trial_balance"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Invoice -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="invoicePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllInvoice"
                        @click="toggleSelectAllInvoice()"
                        label="Invoice"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in invoicePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.invoice"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Payment Voucher -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="paymentVoucherPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllPaymentVoucher"
                        @click="toggleSelectAllPaymentVoucher()"
                        label="Payment Voucher"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in paymentVoucherPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.payment_voucher"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Company Bank Account -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="companyBankAccountPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllCompanyBankAccount"
                        @click="toggleSelectAllCompanyBankAccount()"
                        label="Company Bank Account"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in companyBankAccountPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.company_bank_account"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Receipt -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="receiptPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllReceipt"
                        @click="toggleSelectAllReceipt()"
                        label="Receipt"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in receiptPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.receipt"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Bin Card -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="binCardPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllBinCard"
                        @click="toggleSelectAllBinCard()"
                        label="Bin Card"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in binCardPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.bin_card"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Other Income Types -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="otherIncomeTypesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllOtherIncomeTypes"
                        @click="toggleSelectAllOtherIncomeTypes()"
                        label="Other Income Types"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in otherIncomeTypesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.other_income_types"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Income Entries -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="incomeEntriesPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllIncomeEntries"
                        @click="toggleSelectAllIncomeEntries()"
                        label="Income Entries"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in incomeEntriesPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.income_entries"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <!-- Setting -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="settingPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllSetting"
                        @click="toggleSelectAllSetting()"
                        label="Setting"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in settingPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.setting"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- User -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="userPer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllUser"
                        @click="toggleSelectAllUser()"
                        label="User"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in userPer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.user"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <!-- Role -->
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="6"
            xl="3"
            v-if="rolePer.length > 0"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="10%" style="font-size: 16px;">
                      <v-checkbox
                        v-model="selectAllRole"
                        @click="toggleSelectAllRole()"
                        label="Role"
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in rolePer" :key="item">
                    <td>
                      <v-checkbox
                        v-model="form.role"
                        :label="formatLabel(item)"
                        :value="item"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              :disabled="loading"
              block
              @click="update()"
              >Update</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { RoleService } from "@/services/role-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";

export default {
  name: "EditRole",
  components: { Alert, Snackbars, HeaderDividerBlock },
  props: ["name"],
  data: () => ({
    form: {
      name: "",
      guard_name: "",
      user: [],
      role: [],
      branch: [],
      store: [],
      customer: [],
      Suppliers: [],
      product: [],
      productTax: [],
      requisition: [],
      purchase_order: [],
      grn: [],
      stock: [],
      batch: [],
      stock_transfer: [],
      goods_return_note: [],
      expenses: [],
      expense_types: [],
      gl_account: [],
      gl_sub_headers: [],
      GL_Transactions: [],
      trial_balance: [],
      invoice: [],
      payment_voucher: [],
      company_bank_account: [],
      receipt: [],
      bin_card: [],
      other_income_types: [],
      income_entries: [],
      setting: [],
    },

    snackbar: false,
    isCheckedUser: false,
    isCheckedRole: false,
    isCheckedBranch: false,
    isCheckedStore: false,
    isCheckedCustomer: false,
    isCheckedSuppliers: false,
    isCheckedProduct: false,
    isCheckedProductTax: false,
    isCheckedRequisition: false,
    isCheckedPurchaseOrder: false,
    isCheckedGrn: false,
    isCheckedStock: false,
    isCheckedBatch: false,
    isCheckedStockTransfer: false,
    isCheckedGoodsReturnNote: false,
    isCheckedExpenses: false,
    isCheckedExpenseTypes: false,
    isCheckedGlAccount: false,
    isCheckedGlSubHeaders: false,
    isCheckedGlTransactions: false,
    isCheckedTrialBalance: false,
    isCheckedInvoice: false,
    isCheckedPaymentVoucher: false,
    isCheckedCompanyBankAccount: false,
    isCheckedReceipt: false,
    isCheckedBinCard: false,
    isCheckedOtherIncomeTypes: false,
    isCheckedIncomeEntries: false,
    isCheckedSetting: false,
    snackbarError: false,
    perArray: [],
    successMsg: "Role has been updated successfully",
    errors: null,
    loading: false,
    permissions: [],
    selectAllUser: false,
    selectAllRole: false,
    selectAllBranch: false,
    selectAllStore: false,
    selectAllCustomer: false,
    selectAllSuppliers: false,
    selectAllProduct: false,
    selectAllProductTax: false,
    selectAllRequisition: false,
    selectAllPurchaseOrder: false,
    selectAllGrn: false,
    selectAllStock: false,
    selectAllBatch: false,
    selectAllStockTransfer: false,
    selectAllGoodsReturnNote: false,
    selectAllExpenses: false,
    selectAllExpenseTypes: false,
    selectAllGlAccount: false,
    selectAllGlSubHeaders: false,
    selectAllGlTransactions: false,
    selectAllTrialBalance: false,
    selectAllInvoice: false,
    selectAllPaymentVoucher: false,
    selectAllCompanyBankAccount: false,
    selectAllReceipt: false,
    selectAllBinCard: false,
    selectAllOtherIncomeTypes: false,
    selectAllIncomeEntries: false,
    selectAllSetting: false,
    userPer: [],
    rolePer: [],
    branchPer: [],
    storePer: [],
    customerPer: [],
    suppliersPer: [],
    productPer: [],
    productTaxPer: [],
    requisitionPer: [],
    purchaseOrderPer: [],
    grnPer: [],
    stockPer: [],
    batchPer: [],
    stockTransferPer: [],
    goodsReturnNotePer: [],
    expensesPer: [],
    expenseTypesPer: [],
    glAccountPer: [],
    glSubHeadersPer: [],
    glTransactionsPer: [],
    trialBalancePer: [],
    invoicePer: [],
    paymentVoucherPer: [],
    companyBankAccountPer: [],
    receiptPer: [],
    binCardPer: [],
    otherIncomeTypesPer: [],
    incomeEntriesPer: [],
    settingPer: [],
  }),

  mounted() {
    this.getPermissionList();
    this.getRoleInfo();
  },

  methods: {
    update() {
      this.loading = true;
      this.errors = null;

      if (this.isCheckedUser) {
        const permissionsStringUser = this.userPer.join(",");
        this.form.user = permissionsStringUser;
      }
      if (this.form.user) {
        this.perArray.push(this.form.user);
      }

      if (this.isCheckedRole) {
        const permissionsStringRole = this.rolePer.join(",");
        this.form.role = permissionsStringRole;
      }
      if (this.form.role) {
        this.perArray.push(this.form.role);
      }

      if (this.isCheckedBranch) {
        const permissionsString = this.branchPer.join(",");
        this.form.branch = permissionsString;
      }
      if (this.form.branch) this.perArray.push(this.form.branch);

      if (this.isCheckedStore) {
        const permissionsString = this.storePer.join(",");
        this.form.store = permissionsString;
      }
      if (this.form.store) this.perArray.push(this.form.store);

      if (this.isCheckedCustomer) {
        const permissionsString = this.customerPer.join(",");
        this.form.customer = permissionsString;
      }
      if (this.form.customer) this.perArray.push(this.form.customer);

      if (this.isCheckedSuppliers) {
        const permissionsString = this.suppliersPer.join(",");
        this.form.Suppliers = permissionsString;
      }
      if (this.form.Suppliers) this.perArray.push(this.form.Suppliers);

      if (this.isCheckedProduct) {
        const permissionsString = this.productPer.join(",");
        this.form.product = permissionsString;
      }
      if (this.form.product) this.perArray.push(this.form.product);

      if (this.isCheckedProductTax) {
        const permissionsString = this.productTaxPer.join(",");
        this.form.productTax = permissionsString;
      }
      if (this.form.productTax) this.perArray.push(this.form.productTax);

      if (this.isCheckedRequisition) {
        const permissionsString = this.requisitionPer.join(",");
        this.form.requisition = permissionsString;
      }
      if (this.form.requisition) this.perArray.push(this.form.requisition);

      if (this.isCheckedPurchaseOrder) {
        const permissionsString = this.purchaseOrderPer.join(",");
        this.form.purchase_order = permissionsString;
      }
      if (this.form.purchase_order)
        this.perArray.push(this.form.purchase_order);

      if (this.isCheckedGrn) {
        const permissionsString = this.grnPer.join(",");
        this.form.grn = permissionsString;
      }
      if (this.form.grn) this.perArray.push(this.form.grn);

      if (this.isCheckedStock) {
        const permissionsString = this.stockPer.join(",");
        this.form.stock = permissionsString;
      }
      if (this.form.stock) this.perArray.push(this.form.stock);

      if (this.isCheckedBatch) {
        const permissionsString = this.batchPer.join(",");
        this.form.batch = permissionsString;
      }
      if (this.form.batch) this.perArray.push(this.form.batch);

      if (this.isCheckedStockTransfer) {
        const permissionsString = this.stockTransferPer.join(",");
        this.form.stock_transfer = permissionsString;
      }
      if (this.form.stock_transfer)
        this.perArray.push(this.form.stock_transfer);

      if (this.isCheckedGoodsReturnNote) {
        const permissionsString = this.goodsReturnNotePer.join(",");
        this.form.goods_return_note = permissionsString;
      }
      if (this.form.goods_return_note)
        this.perArray.push(this.form.goods_return_note);

      if (this.isCheckedExpenses) {
        const permissionsString = this.expensesPer.join(",");
        this.form.expenses = permissionsString;
      }
      if (this.form.expenses) this.perArray.push(this.form.expenses);

      if (this.isCheckedExpenseTypes) {
        const permissionsString = this.expenseTypesPer.join(",");
        this.form.expense_types = permissionsString;
      }
      if (this.form.expense_types) this.perArray.push(this.form.expense_types);

      if (this.isCheckedGlAccount) {
        const permissionsString = this.glAccountPer.join(",");
        this.form.gl_account = permissionsString;
      }
      if (this.form.gl_account) this.perArray.push(this.form.gl_account);

      if (this.isCheckedGlSubHeaders) {
        const permissionsString = this.glSubHeadersPer.join(",");
        this.form.gl_sub_headers = permissionsString;
      }
      if (this.form.gl_sub_headers)
        this.perArray.push(this.form.gl_sub_headers);

      if (this.isCheckedGlTransactions) {
        const permissionsString = this.glTransactionsPer.join(",");
        this.form.GL_Transactions = permissionsString;
      }
      if (this.form.GL_Transactions)
        this.perArray.push(this.form.GL_Transactions);

      if (this.isCheckedTrialBalance) {
        const permissionsString = this.trialBalancePer.join(",");
        this.form.trial_balance = permissionsString;
      }
      if (this.form.trial_balance) this.perArray.push(this.form.trial_balance);

      if (this.isCheckedInvoice) {
        const permissionsString = this.invoicePer.join(",");
        this.form.invoice = permissionsString;
      }
      if (this.form.invoice) this.perArray.push(this.form.invoice);

      if (this.isCheckedPaymentVoucher) {
        const permissionsString = this.paymentVoucherPer.join(",");
        this.form.payment_voucher = permissionsString;
      }
      if (this.form.payment_voucher)
        this.perArray.push(this.form.payment_voucher);

      if (this.isCheckedCompanyBankAccount) {
        const permissionsString = this.companyBankAccountPer.join(",");
        this.form.company_bank_account = permissionsString;
      }
      if (this.form.company_bank_account)
        this.perArray.push(this.form.company_bank_account);

      if (this.isCheckedReceipt) {
        const permissionsString = this.receiptPer.join(",");
        this.form.receipt = permissionsString;
      }
      if (this.form.receipt) this.perArray.push(this.form.receipt);

      if (this.isCheckedBinCard) {
        const permissionsString = this.binCardPer.join(",");
        this.form.bin_card = permissionsString;
      }
      if (this.form.bin_card) this.perArray.push(this.form.bin_card);

      if (this.isCheckedOtherIncomeTypes) {
        const permissionsString = this.otherIncomeTypesPer.join(",");
        this.form.other_income_types = permissionsString;
      }
      if (this.form.other_income_types)
        this.perArray.push(this.form.other_income_types);

      if (this.isCheckedIncomeEntries) {
        const permissionsString = this.incomeEntriesPer.join(",");
        this.form.income_entries = permissionsString;
      }
      if (this.form.income_entries)
        this.perArray.push(this.form.income_entries);

      if (this.isCheckedSetting) {
        const permissionsString = this.settingPer.join(",");
        this.form.setting = permissionsString;
      }
      if (this.form.setting) this.perArray.push(this.form.setting);

      this.form.data = this.perArray;

      let fd = new FormData();

      fd.append("name", this.form.name);
      fd.append("guard_name", this.form.guard_name);
      fd.append("permissions", this.form.data || "");
      fd.append("oldName", this.form.oldName);

      RoleService.editRole(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
            this.$router.push("/roles");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    toggleSelectAllUser() {
      if (this.selectAllUser) {
        this.isCheckedUser = true;
        this.form.user = this.userPer;
      } else {
        this.isCheckedUser = false;
        this.form.user = [];
      }
    },

    toggleSelectAllRole() {
      if (this.selectAllRole) {
        this.isCheckedRole = true;
        this.form.role = this.rolePer;
      } else {
        this.isCheckedRole = false;
        this.form.role = [];
      }
    },

    toggleSelectAllBranch() {
      if (this.selectAllBranch) {
        this.isCheckedBranch = true;
        this.form.branch = this.branchPer;
      } else {
        this.isCheckedBranch = false;
        this.form.branch = [];
      }
    },
    toggleSelectAllStore() {
      if (this.selectAllStore) {
        this.isCheckedStore = true;
        this.form.store = this.storePer;
      } else {
        this.isCheckedStore = false;
        this.form.store = [];
      }
    },
    toggleSelectAllCustomer() {
      if (this.selectAllCustomer) {
        this.isCheckedCustomer = true;
        this.form.customer = this.customerPer;
      } else {
        this.isCheckedCustomer = false;
        this.form.customer = [];
      }
    },
    toggleSelectAllSuppliers() {
      if (this.selectAllSuppliers) {
        this.isCheckedSuppliers = true;
        this.form.Suppliers = this.suppliersPer;
      } else {
        this.isCheckedSuppliers = false;
        this.form.Suppliers = [];
      }
    },
    toggleSelectAllProduct() {
      if (this.selectAllProduct) {
        this.isCheckedProduct = true;
        this.form.product = this.productPer;
      } else {
        this.isCheckedProduct = false;
        this.form.product = [];
      }
    },
    toggleSelectAllProductTax() {
      if (this.selectAllProductTax) {
        this.isCheckedProductTax = true;
        this.form.productTax = this.productTaxPer;
      } else {
        this.isCheckedProductTax = false;
        this.form.productTax = [];
      }
    },
    toggleSelectAllRequisition() {
      if (this.selectAllRequisition) {
        this.isCheckedRequisition = true;
        this.form.requisition = this.requisitionPer;
      } else {
        this.isCheckedRequisition = false;
        this.form.requisition = [];
      }
    },
    toggleSelectAllPurchaseOrder() {
      if (this.selectAllPurchaseOrder) {
        this.isCheckedPurchaseOrder = true;
        this.form.purchase_order = this.purchaseOrderPer;
      } else {
        this.isCheckedPurchaseOrder = false;
        this.form.purchase_order = [];
      }
    },
    toggleSelectAllGrn() {
      if (this.selectAllGrn) {
        this.isCheckedGrn = true;
        this.form.grn = this.grnPer;
      } else {
        this.isCheckedGrn = false;
        this.form.grn = [];
      }
    },
    toggleSelectAllStock() {
      if (this.selectAllStock) {
        this.isCheckedStock = true;
        this.form.stock = this.stockPer;
      } else {
        this.isCheckedStock = false;
        this.form.stock = [];
      }
    },
    toggleSelectAllBatch() {
      if (this.selectAllBatch) {
        this.isCheckedBatch = true;
        this.form.batch = this.batchPer;
      } else {
        this.isCheckedBatch = false;
        this.form.batch = [];
      }
    },
    toggleSelectAllStockTransfer() {
      if (this.selectAllStockTransfer) {
        this.isCheckedStockTransfer = true;
        this.form.stock_transfer = this.stockTransferPer;
      } else {
        this.isCheckedStockTransfer = false;
        this.form.stock_transfer = [];
      }
    },
    toggleSelectAllGoodsReturnNote() {
      if (this.selectAllGoodsReturnNote) {
        this.isCheckedGoodsReturnNote = true;
        this.form.goods_return_note = this.goodsReturnNotePer;
      } else {
        this.isCheckedGoodsReturnNote = false;
        this.form.goods_return_note = [];
      }
    },
    toggleSelectAllExpenses() {
      if (this.selectAllExpenses) {
        this.isCheckedExpenses = true;
        this.form.expenses = this.expensesPer;
      } else {
        this.isCheckedExpenses = false;
        this.form.expenses = [];
      }
    },
    toggleSelectAllExpenseTypes() {
      if (this.selectAllExpenseTypes) {
        this.isCheckedExpenseTypes = true;
        this.form.expense_types = this.expenseTypesPer;
      } else {
        this.isCheckedExpenseTypes = false;
        this.form.expense_types = [];
      }
    },
    toggleSelectAllGlAccount() {
      if (this.selectAllGlAccount) {
        this.isCheckedGlAccount = true;
        this.form.gl_account = this.glAccountPer;
      } else {
        this.isCheckedGlAccount = false;
        this.form.gl_account = [];
      }
    },
    toggleSelectAllGlSubHeaders() {
      if (this.selectAllGlSubHeaders) {
        this.isCheckedGlSubHeaders = true;
        this.form.gl_sub_headers = this.glSubHeadersPer;
      } else {
        this.isCheckedGlSubHeaders = false;
        this.form.gl_sub_headers = [];
      }
    },
    toggleSelectAllGlTransactions() {
      if (this.selectAllGlTransactions) {
        this.isCheckedGlTransactions = true;
        this.form.GL_Transactions = this.glTransactionsPer;
      } else {
        this.isCheckedGlTransactions = false;
        this.form.GL_Transactions = [];
      }
    },
    toggleSelectAllTrialBalance() {
      if (this.selectAllTrialBalance) {
        this.isCheckedTrialBalance = true;
        this.form.trial_balance = this.trialBalancePer;
      } else {
        this.isCheckedTrialBalance = false;
        this.form.trial_balance = [];
      }
    },
    toggleSelectAllInvoice() {
      if (this.selectAllInvoice) {
        this.isCheckedInvoice = true;
        this.form.invoice = this.invoicePer;
      } else {
        this.isCheckedInvoice = false;
        this.form.invoice = [];
      }
    },
    toggleSelectAllPaymentVoucher() {
      if (this.selectAllPaymentVoucher) {
        this.isCheckedPaymentVoucher = true;
        this.form.payment_voucher = this.paymentVoucherPer;
      } else {
        this.isCheckedPaymentVoucher = false;
        this.form.payment_voucher = [];
      }
    },
    toggleSelectAllCompanyBankAccount() {
      if (this.selectAllCompanyBankAccount) {
        this.isCheckedCompanyBankAccount = true;
        this.form.company_bank_account = this.companyBankAccountPer;
      } else {
        this.isCheckedCompanyBankAccount = false;
        this.form.company_bank_account = [];
      }
    },
    toggleSelectAllReceipt() {
      if (this.selectAllReceipt) {
        this.isCheckedReceipt = true;
        this.form.receipt = this.receiptPer;
      } else {
        this.isCheckedReceipt = false;
        this.form.receipt = [];
      }
    },
    toggleSelectAllBinCard() {
      if (this.selectAllBinCard) {
        this.isCheckedBinCard = true;
        this.form.bin_card = this.binCardPer;
      } else {
        this.isCheckedBinCard = false;
        this.form.bin_card = [];
      }
    },
    toggleSelectAllOtherIncomeTypes() {
      if (this.selectAllOtherIncomeTypes) {
        this.isCheckedOtherIncomeTypes = true;
        this.form.other_income_types = this.otherIncomeTypesPer;
      } else {
        this.isCheckedOtherIncomeTypes = false;
        this.form.other_income_types = [];
      }
    },
    toggleSelectAllIncomeEntries() {
      if (this.selectAllIncomeEntries) {
        this.isCheckedIncomeEntries = true;
        this.form.income_entries = this.incomeEntriesPer;
      } else {
        this.isCheckedIncomeEntries = false;
        this.form.income_entries = [];
      }
    },
    toggleSelectAllSetting() {
      if (this.selectAllSetting) {
        this.isCheckedSetting = true;
        this.form.setting = this.settingPer;
      } else {
        this.isCheckedSetting = false;
        this.form.setting = [];
      }
    },

    getRoleInfo() {
      this.loading = true;
      RoleService.getRoleInfo(this.$route.params.name)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            const roleData = response.data.data;
            console.log("inside getRoleInfo", roleData);
            this.setDefaultFormValues(roleData);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    setDefaultFormValues(roleData) {
      this.form = {
        ...this.form,
        name: roleData.name || "",
        guard_name: roleData.guard_name || "",
        permission: roleData.permissions || "",
        oldName: roleData.name || "",
      };

      this.form.user = this.form.permission
        .filter((perm) => perm.model === "user")
        .map((perm) => perm.name);

      this.form.role = this.form.permission
        .filter((perm) => perm.model === "role")
        .map((perm) => perm.name);

      this.form.branch = this.form.permission
        .filter((perm) => perm.model === "branch")
        .map((perm) => perm.name);
      this.form.store = this.form.permission
        .filter((perm) => perm.model === "store")
        .map((perm) => perm.name);
      this.form.customer = this.form.permission
        .filter((perm) => perm.model === "customer")
        .map((perm) => perm.name);
      this.form.Suppliers = this.form.permission
        .filter((perm) => perm.model === "Suppliers")
        .map((perm) => perm.name);
      this.form.product = this.form.permission
        .filter((perm) => perm.model === "product")
        .map((perm) => perm.name);
      this.form.productTax = this.form.permission
        .filter((perm) => perm.model === "productTax")
        .map((perm) => perm.name);
      this.form.requisition = this.form.permission
        .filter((perm) => perm.model === "requisition")
        .map((perm) => perm.name);
      this.form.purchase_order = this.form.permission
        .filter((perm) => perm.model === "purchase_order")
        .map((perm) => perm.name);
      this.form.grn = this.form.permission
        .filter((perm) => perm.model === "grn")
        .map((perm) => perm.name);
      this.form.stock = this.form.permission
        .filter((perm) => perm.model === "stock")
        .map((perm) => perm.name);
      this.form.batch = this.form.permission
        .filter((perm) => perm.model === "batch")
        .map((perm) => perm.name);
      this.form.stock_transfer = this.form.permission
        .filter((perm) => perm.model === "stock_transfer")
        .map((perm) => perm.name);
      this.form.goods_return_note = this.form.permission
        .filter((perm) => perm.model === "goods_return_note")
        .map((perm) => perm.name);
      this.form.expenses = this.form.permission
        .filter((perm) => perm.model === "expenses")
        .map((perm) => perm.name);
      this.form.expense_types = this.form.permission
        .filter((perm) => perm.model === "expense_types")
        .map((perm) => perm.name);
      this.form.gl_account = this.form.permission
        .filter((perm) => perm.model === "gl_account")
        .map((perm) => perm.name);
      this.form.gl_sub_headers = this.form.permission
        .filter((perm) => perm.model === "gl_sub_headers")
        .map((perm) => perm.name);
      this.form.GL_Transactions = this.form.permission
        .filter((perm) => perm.model === "GL_Transactions")
        .map((perm) => perm.name);
      this.form.trial_balance = this.form.permission
        .filter((perm) => perm.model === "trial_balance")
        .map((perm) => perm.name);
      this.form.invoice = this.form.permission
        .filter((perm) => perm.model === "invoice")
        .map((perm) => perm.name);
      this.form.payment_voucher = this.form.permission
        .filter((perm) => perm.model === "payment_voucher")
        .map((perm) => perm.name);
      this.form.company_bank_account = this.form.permission
        .filter((perm) => perm.model === "company_bank_account")
        .map((perm) => perm.name);
      this.form.receipt = this.form.permission
        .filter((perm) => perm.model === "receipt")
        .map((perm) => perm.name);
      this.form.bin_card = this.form.permission
        .filter((perm) => perm.model === "bin_card")
        .map((perm) => perm.name);
      this.form.other_income_types = this.form.permission
        .filter((perm) => perm.model === "other_income_types")
        .map((perm) => perm.name);
      this.form.income_entries = this.form.permission
        .filter((perm) => perm.model === "income_entries")
        .map((perm) => perm.name);
      this.form.setting = this.form.permission
        .filter((perm) => perm.model === "setting")
        .map((perm) => perm.name);
    },

    getPermissionList() {
      this.loading = true;
      RoleService.getPermissionList()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.permissions = response.data;
            this.userPer = this.permissions.user || [];
            this.rolePer = this.permissions.role || [];
            this.branchPer = this.permissions.branch || [];
            this.storePer = this.permissions.store || [];
            this.customerPer = this.permissions.customer || [];
            this.suppliersPer = this.permissions.Suppliers || [];
            this.productPer = this.permissions.product || [];
            this.productTaxPer = this.permissions.productTax || [];
            this.requisitionPer = this.permissions.requisition || [];
            this.purchaseOrderPer = this.permissions.purchase_order || [];
            this.grnPer = this.permissions.grn || [];
            this.stockPer = this.permissions.stock || [];
            this.batchPer = this.permissions.batch || [];
            this.stockTransferPer = this.permissions.stock_transfer || [];
            this.goodsReturnNotePer = this.permissions.goods_return_note || [];
            this.expensesPer = this.permissions.expenses || [];
            this.expenseTypesPer = this.permissions.expense_types || [];
            this.glAccountPer = this.permissions.gl_account || [];
            this.glSubHeadersPer = this.permissions.gl_sub_headers || [];
            this.glTransactionsPer = this.permissions.GL_Transactions || [];
            this.trialBalancePer = this.permissions.trial_balance || [];
            this.invoicePer = this.permissions.invoice || [];
            this.paymentVoucherPer = this.permissions.payment_voucher || [];
            this.companyBankAccountPer =
              this.permissions.company_bank_account || [];
            this.receiptPer = this.permissions.receipt || [];
            this.binCardPer = this.permissions.bin_card || [];
            this.otherIncomeTypesPer =
              this.permissions.other_income_types || [];
            this.incomeEntriesPer = this.permissions.income_entries || [];
            this.settingPer = this.permissions.setting || [];
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = {
        name: "",
        guard_name: "",
        branch: [],
        store: [],
        customer: [],
        Suppliers: [],
        product: [],
        productTax: [],
        requisition: [],
        purchase_order: [],
        grn: [],
        stock: [],
        batch: [],
        stock_transfer: [],
        goods_return_note: [],
        expenses: [],
        expense_types: [],
        gl_account: [],
        gl_sub_headers: [],
        GL_Transactions: [],
        trial_balance: [],
        invoice: [],
        payment_voucher: [],
        company_bank_account: [],
        receipt: [],
        bin_card: [],
        other_income_types: [],
        income_entries: [],
        setting: [],
        oldName: "",
        permission: [],
      };
      this.perArray = [];
    },
    formatLabel(label) {
      const parts = label.split(".");
      return parts[parts.length - 1].replace(/_/g, " ");
    },
  },
};
</script>
